import React, { Component } from 'react'
import { Modal } from "react-bootstrap";
import PropTypes from 'prop-types';
// Leaf component: every caller is locale-aware and this is not memoized, so it re-renders
// (and re-reads t) whenever the language changes.
import { t } from '../i18n';

export default class ModalInfo extends Component {
    render() {
        const { text, onHide, show, children, modalClass } = this.props;
        return (
            <Modal show={show} className={`modal__center ${modalClass ? modalClass : ''}`} onHide={() => onHide()}>
                <Modal.Body>
                    {children ?
                        children
                        :
                        <div>
                            <p className={'info_message'}>{text}</p>
                            <div className="text-right">
                                <button className="btn info__btn" onClick={() => onHide()}>{t('common.actions.ok')}</button>
                            </div>
                        </div>
                    }

                </Modal.Body>
            </Modal>
        );

    }
}

ModalInfo.propTypes = {
    show: PropTypes.bool,
    text: PropTypes.string,
    onHide: PropTypes.func,
    modalClass: PropTypes.string
}
